import { IDataTableColumn, showError, useApiEffect, useGridState } from "nsitools-react";
import * as React from "react";

import { DysplasiaRequestApi, FileDownload, ShpDocumentDto } from "../../../api";
import { CustomDataTable, SharepointFileButton } from "../../../components";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { b64toBlob } from "../../../utils";
import { saveAs } from "file-saver";

export interface ICommissionRequestFilesListProps {
  sharepointUri: string;
}

export const CommissionRequestFilesList: React.FunctionComponent<ICommissionRequestFilesListProps> = ({
  sharepointUri,
}) => {
  const { t } = useTl();
  const api = useApiService(DysplasiaRequestApi);
  const [filesLoading, setfilesLoading] = React.useState<string[]>([]);
  const tableState = useGridState<ShpDocumentDto>({
    serverMode: false,
    enablePagination: false,
    enableFilter: true,
    data: [],
  });

  const { setData } = tableState;

  const downloadShpDoc = React.useCallback(
    async (fileName) => {
      filesLoading.push(fileName);
      setfilesLoading([...filesLoading]);
      if (fileName) {
        try {
          var file = await api.downloadDysplasiaFile(sharepointUri, fileName);
          var blob = b64toBlob(new FileDownload({ base64Content: file.fileBytes, fileName: file.fileName }));
          saveAs(blob, file.fileName);
        } catch {
          showError(t(ETLCodes.Error));
        }
      }
      setfilesLoading([...filesLoading.filter((c) => c !== fileName)]);
    },
    [api, filesLoading, sharepointUri, t]
  );

  const [files, fLoading] = useApiEffect(() => api.getDysplasiaFileList(sharepointUri), [sharepointUri]);

  React.useEffect(() => {
    if (files) setData(files);
  }, [files, setData]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.FileName),
        fieldName: "fileName",
        render: (row: ShpDocumentDto) => (
          <SharepointFileButton
            tooltip={ETLCodes.ViewFile}
            text={row.fileName}
            onClick={() => downloadShpDoc(row.fileName)}
            loading={!!filesLoading.find((c) => c === row.fileName)}
          />
        ),
      },
      {
        header: () => t(ETLCodes.DocumentType),
        fieldName: "docType",
      },
      {
        header: () => t(ETLCodes.Date),
        fieldName: "date",
      },
    ],
    [downloadShpDoc, filesLoading, t]
  );

  return <CustomDataTable tableState={tableState} columns={columns} loading={fLoading} />;
};
